
import { tokens } from '@/shared/design-system/tokens';
import styled from '@emotion/styled';

export const StatItemContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: ${tokens.typography.fontSize.sm};
  width: 100%;
`;

export const StatLabel = styled.div`
  display: flex;
 
  align-items: center;
  gap: ${tokens.spacing.sm};
`;

export const StatValue = styled.span`
  font-weight: ${tokens.typography.fontWeight.medium};
`;
